module.exports = __webpack_public_path__ + "img/for-you01.c93ea60d.jpg";